export enum AnomalieLayers {
    VEGETATION = 'Végétation',
}
